import * as React from 'react';
import { Dispatch } from 'redux';
import { CreateVgGeneratorJobRequest as FormData } from 'stageclip-common';

import { BaseApiPostRequest } from '../generic/baseApiPostRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import { toFormData } from '../../helpers/requestHelper';

export class CreateVgGeneratorJobRequest extends BaseApiPostRequest<{}, EntityNormalizers.NormalizedEntity<{}>> {
  constructor(eventId: string, formData: FormData, component: React.Component, dispatch: Dispatch) {
    super(formData, component, dispatch);
    this.path = `/generator-jobs/virtual-graduation/${eventId}`;
    this.normalizeMethod = result => result;
  }

  protected generateRequest() {
    const request = super.generateRequest();
    const { clipConfiguration, ...requestBody } = this.body;

    request.body = toFormData(requestBody);

    return request;
  }

  protected generateHeaders() {
    const headers = super.generateHeaders();
    headers.delete('Content-type');

    return headers;
  }
}
